<template>
  <div
    class="roles-main"
    :class="{'ph2-member-page': store.state.user.siteCode === 'PH2'}"
  >
    <el-card class="box-card" shadow="never">
      <template #header>
        <div class="clearfix">
          <span class="role-span">{{ $t('fields.downlineMember') }}</span>
        </div>
      </template>
      <el-form @submit.prevent>
        <button
          v-if="store.state.user.siteCode === 'PH2'"
          type="button"
          class="mobile-filter-toggle"
          :class="{'is-expanded': filtersExpanded}"
          :aria-expanded="filtersExpanded"
          aria-controls="member-filters"
          @click="filtersExpanded = !filtersExpanded"
        >
          <span>{{ $t('fields.filters') }}</span>
          <span
            class="filter-toggle-icon"
            :class="{'is-expanded': filtersExpanded}"
            aria-hidden="true"
          />
        </button>
        <div
          id="member-filters"
          class="member-filters"
          :class="{
            'is-collapsed':
              store.state.user.siteCode === 'PH2' && !filtersExpanded,
          }"
        >
          <div class="member-tag-filter">
            <el-row :gutter="20" v-if="store.state.user.siteCode !== 'VNM'">
            <el-col :xl="2" :lg="3" :md="4" :sm="24">
              <el-form-item :label="t('fields.memberTag') + ' :'" />
            </el-col>
            <el-col :xl="18" :lg="16" :md="12" :sm="24">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAll"
              >
                {{ t('fields.all') }}
              </el-checkbox>
              <el-checkbox-group
                v-model="selected.tags"
                @change="handleCheckedTags"
              >
                <el-checkbox
                  v-for="tag in tagList.description"
                  :key="tag"
                  :label="tag"
                />
              </el-checkbox-group>
            </el-col>
            <el-col
              class="memberTag"
              :xl="3"
              :lg="4"
              :md="12"
              :sm="24"
              style="margin-left: auto; text-align: right;"
            >
              <el-button
                icon="el-icon-setting"
                type="primary"
                @click="goToTagSetting()"
                size="normal"
              >
                {{ $t('fields.tagSetting') }}
              </el-button>
            </el-col>
            </el-row>
          </div>
        <div class="inputs-wrap">
          <el-row :gutter="20">
            <el-col :xl="8" :lg="8" :md="6" :sm="6">
              <el-form-item :label="t('fields.loginName') + ' :'">
                <el-input size="normal" v-model="request.loginName" />
              </el-form-item>
            </el-col>
            <el-col :xl="8" :lg="8" :md="10" :sm="8">
              <el-form-item :label="t('fields.depositAmount') + ' :'">
                <el-input
                  size="normal"
                  v-model="request.depositMinAmount"
                  class="input-min"
                >
                  <template #append>
                    -
                  </template>
                </el-input>
                <el-input
                  v-model="request.depositMaxAmount"
                  class="input-max"
                  size="normal"
                />
              </el-form-item>
            </el-col>
            <el-col :xl="8" :lg="8" :md="6" :sm="6">
              <el-form-item :label="t('fields.betRecord') + ' :'">
                <el-select
                  style="width: 100%;"
                  size="normal"
                  v-model="request.isBet"
                >
                  <el-option key="1" value="-1" :label="t('fields.all')">
                    {{ t('fields.all') }}
                  </el-option>
                  <el-option key="2" value="1" :label="t('fields.yes')">
                    {{ t('fields.yes') }}
                  </el-option>
                  <el-option key="3" value="0" :label="t('fields.no')">
                    {{ t('fields.no') }}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="inputs-wrap">
          <el-row :gutter="20" style="gap: 10px;">
            <el-col :xl="8" :lg="8" :md="12" :sm="12">
              <el-form-item :label="t('fields.recordTime') + ' :'">
                <el-date-picker
                  v-model="request.recordTime"
                  format="DD/MM/YYYY"
                  value-format="YYYY-MM-DD"
                  size="normal"
                  class="input-small"
                  type="daterange"
                  range-separator=":"
                  :start-placeholder="t('fields.startDate')"
                  :end-placeholder="t('fields.endDate')"
                  :shortcuts="shortcuts"
                  :disabled-date="disabledDate"
                  :editable="false"
                  :clearable="false"
                />
              </el-form-item>
            </el-col>
            <el-col :xl="10" :lg="8" :md="12" :sm="12">
              <el-form-item :label="t('fields.registerTime') + ' :'">
                <el-date-picker
                  v-model="request.regTime"
                  format="DD/MM/YYYY"
                  value-format="YYYY-MM-DD"
                  size="normal"
                  class="input-small"
                  type="daterange"
                  range-separator=":"
                  :start-placeholder="t('fields.startDate')"
                  :end-placeholder="t('fields.endDate')"
                  :shortcuts="shortcuts"
                  :disabled-date="disabledDate"
                  :editable="false"
                  :clearable="false"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="inputs-wrap">
          <el-row :gutter="20">
            <el-col :xl="8" :lg="8" :md="6" :sm="6">
              <el-form-item :label="t('fields.downlineAffiliate') + ' :'">
                <el-select
                  style="width: 100%;"
                  size="normal"
                  v-model="request.downlineAffiliate"
                  @focus="getAllAffiliateDownlines"
                  :clearable="true"
                >
                  <el-option
                    v-for="item in affiliate.list"
                    :key="item.affiliateId"
                    :label="item.loginName"
                    :value="item.affiliateId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xl="10" :lg="10" :md="12" :sm="12">
              <el-form-item :label="t('fields.validBet') + ' :'">
                <el-input
                  size="normal"
                  v-model="request.validBetMinAmount"
                  class="input-min"
                >
                  <template #append>
                    -
                  </template>
                </el-input>
                <el-input
                  v-model="request.validBetMaxAmount"
                  class="input-max"
                  size="normal"
                />
              </el-form-item>
            </el-col>
            <el-col :xl="6" :lg="6" :md="4" :sm="4" />
          </el-row>
        </div>
        <div class="inputs-wrap">
          <el-row :gutter="20" style="gap: 10px;">
            <el-col :xl="7" :lg="7" :md="7" :sm="7">
              <el-form-item :label="t('fields.orderBy') + ' :'">
                <el-select
                  style="width: 100%;"
                  size="normal"
                  v-model="request.orderBy"
                >
                  <el-option
                    v-for="item in uiControl.orderBy"
                    :key="item.display"
                    :label="t('fields.' + item.display)"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xl="7" :lg="7" :md="7" :sm="7">
              <el-form-item :label="t('fields.sortType') + ' :'">
                <el-select
                  style="width: 100%;"
                  size="normal"
                  v-model="request.sortType"
                >
                  <el-option
                    v-for="item in uiControl.sortType"
                    :key="item.display"
                    :label="t('sortType.' + item.display)"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xl="8" :lg="8" :md="8">
              <div
                class="member-search-actions"
                style="margin-top: 10px; width: 100%; display: flex; align-items: center; justify-content: center"
              >
                <el-button
                  icon="el-icon-search"
                  type="primary"
                  @click="loadAffiliateMembers()"
                  size="normal"
                >
                  {{ $t('fields.search') }}
                </el-button>
                <el-button
                  size="normal"
                  type="primary"
                  plain
                  @click="resetQuery()"
                >
                  {{ $t('fields.reset') }}
                </el-button>
                <el-button
                  size="normal"
                  type="primary"
                  plain
                  :loading="uiControl.exporting"
                  @click="exportMembers()"
                >
                  {{ $t('fields.export') }}
                </el-button>
                <el-button
                  v-if="store.state.user.siteCode === 'PH2'"
                  class="mobile-batch-edit"
                  size="normal"
                  type="primary"
                  :disabled="uiControl.editBtn"
                  @click="showBatchEditTag()"
                >
                  {{ $t('fields.batchEditTag') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        </div>
        <div class="inputs-wrap member-batch-actions">
          <el-button
            v-if="store.state.user.siteCode === 'KRW'"
            icon="el-icon-plus"
            size="normal"
            type="primary"
            @click="showCreateMember()"
          >
            {{ $t('fields.createMember') }}
          </el-button>
          <el-button
            v-if="store.state.user.siteCode !== 'VNM'"
            class="default-batch-edit"
            size="normal"
            type="primary"
            :disabled="uiControl.editBtn"
            @click="showBatchEditTag()"
          >
            {{ $t('fields.batchEditTag') }}
          </el-button>
          <template v-if="[1, 6, 7].includes(parseInt(store.state.user.siteId))">
            <el-checkbox
              v-model="request.depositedButRecentNoDeposit"
              @change="val => val && (request.thisMonthRegisterAndNoDeposit = false)"
            >
              {{ t('fields.depositedButRecentNoDeposit') }}
            </el-checkbox>
            <el-checkbox
              v-model="request.thisMonthRegisterAndNoDeposit"
              @change="val => val && (request.depositedButRecentNoDeposit = false)"
            >
              {{ t('fields.thisMonthRegisterAndNoDeposit') }}
            </el-checkbox>
          </template>
        </div>
      </el-form>
      <div style="width: 98%; margin: 10px auto; overflow: auto;">
        <table cellpadding="0" cellspacing="0" border="0" class="custom-table">
          <thead>
            <tr>
              <th scope="col">{{ t('fields.sequence') }}</th>
              <th scope="col">{{ t('fields.loginName') }}</th>
              <th
                v-for="col in sortableColumns"
                :key="col.label"
                scope="col"
                :class="{'sortable-th': col.orderBy}"
                @click="col.orderBy && sortBy(col.orderBy)"
              >
                {{ t('fields.' + col.label) }}
                <span v-if="col.orderBy" class="sort-caret">
                  <span
                    class="caret-up"
                    :class="{active: request.orderBy === col.orderBy && request.sortType === 'ASC'}"
                  >▲</span>
                  <span
                    class="caret-down"
                    :class="{active: request.orderBy === col.orderBy && request.sortType === 'DESC'}"
                  >▼</span>
                </span>
              </th>
              <th scope="col">{{ t('fields.lastLoginTime') }}</th>
              <th scope="col">{{ t('fields.memberTag') }}</th>
              <th scope="col">{{ t('fields.operate') }}</th>
            </tr>
          </thead>
          <tbody v-if="page.records.length > 0">
            <tr v-for="item in page.records" :key="item.id">
              <td :data-label="t('fields.sequence')">
                <input
                  type="checkbox"
                  :value="item.id"
                  v-model="selectedMembers"
                  @change="handleSelectionChange"
                >
              </td>
              <td :data-label="t('fields.loginName')">{{ item.loginName }}</td>
              <td :data-label="t('fields.totalDeposit')">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                {{ formatMoney(item.totalDeposit) }}
              </td>
              <td :data-label="t('fields.totalWithdraw')">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                {{ formatMoney(item.totalWithdraw) }}
              </td>
              <td :data-label="t('fields.totalBet')">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                {{ formatMoney(item.totalBet) }}
              </td>
              <td :data-label="t('fields.netProfit')">
                {{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}
                {{ formatMoney(item.revenueShare) }}
              </td>
              <td :data-label="t('fields.regTime')">
                <span v-if="item.regTime === null">-</span>
                <span>{{ formatDateTime(item.regTime) }}</span>
              </td>
              <td :data-label="t('fields.lastLoginTime')">
                <span v-if="item.lastLoginTime === null">-</span>
                <span>{{ formatDateTime(item.lastLoginTime) }}</span>
              </td>
              <td :data-label="t('fields.memberTag')">
                {{ formatmTag(item.tagDesc) }}
              </td>
              <td class="relativerow" :data-label="t('fields.operate')">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    {{ t('fields.more') }}
                    <el-icon class="el-icon--right">
                      <arrow-down />
                    </el-icon>
                  </span>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item @click="showMemberInfo(item)">
                        {{ t('fields.memberInfo') }}
                      </el-dropdown-item>
                      <el-dropdown-item
                        v-if="showOperation"
                        @click="transferRedirect(item.loginName)"
                      >
                        {{ t('menu.Transfer') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click="showEditTag(item)" v-if="showOperation">
                        {{ t('fields.editTag') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click="showEditRemark(item)" v-if="showOperation">
                        {{ t('fields.remark') }}
                      </el-dropdown-item>
                      <el-dropdown-item v-if="parseInt(store.state.user.siteId) === 10 && showOperation" @click="showEditShareRatio(item)">
                        {{ t('fields.editShareRatio') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click="showDepositRecord(item)">
                        {{ t('fields.depositRecord') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click="showGameRecord(item.loginName, downlineAffiliate)">
                        {{ t('fields.betRecord') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click="showPrivilegeRecord(item)">
                        {{ t('fields.privilegeRecord') }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-if="page.records.length === 0">
          <emptyComp />
        </div>
        <el-pagination
          class="pagination"
          @current-change="changePage"
          layout="prev, pager, next"
          :page-size="request.size"
          :page-count="page.pages"
          :current-page="request.current"
        />
      </div>
    </el-card>
  </div>
  <el-dialog
    :title="t('fields.memberInfo')"
    v-model="uiControl.infoDialogVisible"
    modal-class="dialog900"
    width="90%"
  >
    <el-form>
      <div style="display: flex; gap: 10px;">
        <el-row :gutter="20" style="gap: 10px">
          <el-col :xl="8" :lg="18" :md="16" :xs="16">
            <el-form-item :label="t('fields.recordTime') + ' :'">
              <el-date-picker
                v-model="memberRequest.recordTime"
                format="DD/MM/YYYY"
                value-format="YYYY-MM-DD"
                size="normal"
                class="input-small"
                type="daterange"
                range-separator=":"
                :start-placeholder="t('fields.startDate')"
                :end-placeholder="t('fields.endDate')"
                :shortcuts="shortcuts"
                :disabled-date="disabledDate"
                :editable="false"
                :clearable="false"
              />
            </el-form-item>
          </el-col>
          <el-col :xl="8" :lg="8" :md="6" :sm="6">
            <el-form-item :label="t('fields.gameType') + ' :'">
              <el-select
                style="width: 100%;"
                size="normal"
                v-model="memberRequest.gameType"
              >
                <el-option key="1" value="" :label="t('fields.all')">
                  {{ t('fields.all') }}
                </el-option>
                <el-option key="2" value="LOTTERY" :label="t('fields.lottery')">
                  {{ t('fields.lottery') }}
                </el-option>
                <el-option key="3" value="OTHERS" :label="t('fields.others')">
                  {{ t('fields.others') }}
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xl="5" :lg="3" :md="3" :xs="3">
            <el-button
              icon="el-icon-search"
              type="primary"
              @click="showMemberInfo()"
              size="normal"
            >
              {{ $t('fields.search') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="scrollable-container" v-loading="dialog.loading">
      <div class="info-container">
        <el-form label-suffix=" : ">
          <div class="info-row-container">
            <el-form-item :label="t('fields.loginName')">
              {{ memberInfo.loginName }}
            </el-form-item>
            <el-form-item :label="t('fields.status')">
              <el-tag
                v-if="memberInfo.status === 'NORMAL'"
                type="success"
                size="normal"
              >
                {{ t('member.status.normal') }}
              </el-tag>
              <el-tag
                v-if="memberInfo.status === 'FROZEN'"
                type="danger"
                size="normal"
              >
                {{ t('member.status.frozen') }}
              </el-tag>
              <el-tag
                v-if="memberInfo.status === null"
                type="info"
                size="normal"
              >
                -
              </el-tag>
            </el-form-item>
            <el-form-item :label="t('fields.deposit')">
              {{ memberInfo.totalDeposit }}
            </el-form-item>
            <el-form-item :label="t('fields.withdraw')">
              {{ memberInfo.totalWithdraw }}
            </el-form-item>
            <el-form-item :label="t('fields.bonus')">
              {{ memberInfo.totalBonus }}
            </el-form-item>
          </div>
          <div class="info-row-container">
            <el-form-item :label="t('fields.rebate')">
              {{ memberInfo.totalRebate }}
            </el-form-item>
            <el-form-item :label="t('fields.validBet')">
              {{ memberInfo.totalValidBet }}
            </el-form-item>
            <el-form-item :label="t('fields.totalBet')">
              {{ memberInfo.totalBet }}
            </el-form-item>
            <el-form-item :label="t('fields.adjustAmount')">
              {{ memberInfo.totalAdjustment }}
            </el-form-item>
            <el-form-item :label="t('fields.winLoss')">
              {{ memberInfo.winLoss }}
            </el-form-item>
          </div>
          <div class="info-row-container">
            <el-form-item :label="t('fields.registerTime')">
              {{ memberInfo.regTime }}
            </el-form-item>
            <el-form-item :label="t('fields.ftdTime')">
              {{ memberInfo.ftdTime }}
            </el-form-item>
            <el-form-item :label="t('fields.transferRecord')">
              {{ memberInfo.transferRecord }}
            </el-form-item>
          </div>
          <div class="info-row-container">
            <el-form-item :label="t('fields.memberTag')">
              {{ memberInfo.tags }}
            </el-form-item>
          </div>
          <div class="info-row-container">
            <el-form-item :label="t('fields.remark')">
              {{ memberInfo.remark }}
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div style="width: 95%; margin: 10px auto">
        <table class="custom-table">
          <thead>
            <tr>
              <th scope="col">{{ t('fields.sequence') }}</th>
              <th scope="col">{{ t('fields.platform') }}</th>
              <th scope="col">{{ t('fields.validBet') }}</th>
              <th scope="col">{{ t('fields.winLoss') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="memberInfo.memberBetRecordSummaryVOList.length === 0">
              <td colspan="4">
                <!-- Display your empty component or message here -->
                <emptyComp />
              </td>
            </tr>
            <tr
              v-for="(record, index) in memberInfo.memberBetRecordSummaryVOList"
              :key="index"
            >
              <td :data-label="t('fields.sequence')">{{ index + 1 }}</td>
              <td :data-label="t('fields.platform')">
                {{ record.platform + ' - ' + record.gameType }}
              </td>
              <td :data-label="t('fields.validBet')">{{ record.validBet }}</td>
              <td :data-label="t('fields.winLoss')">{{ record.winLoss }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    :title="t('fields.editTag')"
    v-model="uiControl.tagDialogVisible"
    append-to-body
    width="90%"
    modal-class="dialog400"
  >
    <el-form @submit.prevent>
      <el-form-item :label="t('fields.loginName')">
        <b v-if="uiControl.editType === 'One'">
          {{ selectedMember.loginName }}
        </b>
        <b v-else>{{ selectedMemberList.loginName.join(', ') }}</b>
      </el-form-item>
      <el-form-item :label="t('fields.memberTag')">
        <el-checkbox-group v-model="tagRequest.tags">
          <el-checkbox
            v-for="tag in assignTaglist"
            :key="tag.id"
            :label="tag.description"
          />
        </el-checkbox-group>
      </el-form-item>
    </el-form>

    <div class="dialog-footer">
      <el-button @click="uiControl.tagDialogVisible = false">
        {{ $t('fields.cancel') }}
      </el-button>
      <el-button type="primary" @click="submitTag()">
        {{ $t('fields.confirm') }}
      </el-button>
    </div>
  </el-dialog>
  <el-dialog
    :title="t('fields.editTag')"
    v-model="uiControl.remarkDialogVisible"
    append-to-body
  >
    <el-form @submit.prevent>
      <el-form-item :label="t('fields.loginName')">
        <b>{{ selectedMember.loginName }}</b>
      </el-form-item>
      <el-form-item :label="t('fields.remark')">
        <el-input
          v-model="selectedMember.remark"
          :rows="2"
          type="textarea"
          :placeholder="t('message.remarkMessage')"
        />
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="uiControl.remarkDialogVisible = false">
        {{ $t('fields.cancel') }}
      </el-button>
      <el-button type="primary" @click="submitRemark()">
        {{ $t('fields.confirm') }}
      </el-button>
    </div>
  </el-dialog>

  <el-dialog
    :title="t('fields.editShareRatio')"
    v-model="uiControl.shareRatioDialogVisible"
    width="500px"
    append-to-body
  >
    <el-form @submit.prevent>
      <el-form-item prop="memberShareRatio">
        <div v-for="item in selectedMember.shareRatio" :key="item.code" style="display: flex; margin-bottom:5px;">
          <span>{{ t('affiliateShareRatio.' + item.code) }}</span>
          <el-input
            v-model="item.value"
            style=" width:100px; margin-left: auto;"
          />
          <span style="color:red"> &emsp; (0 - {{ getAffiliateRatio(item.code) }}) </span>
        </div>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="uiControl.remarkDialogVisible = false">
        {{ $t('fields.cancel') }}
      </el-button>
      <el-button type="primary" @click="submitShareRatio()">
        {{ $t('fields.confirm') }}
      </el-button>
    </div>
  </el-dialog>

  <el-dialog
    :title="t('fields.depositRecord')"
    v-model="uiControl.depositDialogVisible"
    width="1100px"
    append-to-body
  >
    <el-form label-suffix=" : " style="margin-top: -20px;">
      <div class="info-row-container">
        <el-form-item :label="t('fields.loginName')">
          {{ memberDepositInfo.loginName }}
        </el-form-item>
        <el-form-item :label="t('fields.realName')">
          {{ memberDepositInfo.realName }}
        </el-form-item>
        <el-form-item :label="t('fields.registerTime')">
          {{ memberDepositInfo.regTime }}
        </el-form-item>
      </div>
      <table class="custom-table">
        <thead>
          <tr>
            <th scope="col">{{ t('fields.sequence') }}</th>
            <th scope="col">{{ t('fields.serialNumber') }}</th>
            <th scope="col">{{ t('fields.paymentType') }}</th>
            <th scope="col">{{ t('fields.depositAmount') }}</th>
            <th scope="col">{{ t('fields.depositDate') }}</th>
            <th scope="col">{{ t('fields.finishDate') }}</th>
            <th scope="col">{{ t('fields.status') }}</th>
          </tr>
        </thead>
        <tbody v-if="memberDepositInfo.page.records.length > 0">
          <tr
            v-for="(item, index) in memberDepositInfo.page.records"
            :key="item.id"
          >
            <td :data-label="t('fields.sequence')">{{ (depositRequest.current - 1) * 10 + index + 1 }}</td>
            <td :data-label="t('fields.serialNumber')">{{ item.serialNumber }}</td>
            <td :data-label="t('fields.paymentType')">{{ item.paymentType }}</td>
            <td :data-label="t('fields.depositAmount')">{{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}{{ parseInt(store.state.user.siteId) === 10 ? item.depositAmount.toFixed(0) : item.depositAmount.toFixed(2) }}</td>
            <td :data-label="t('fields.depositDate')">
              {{ formatDate(item.depositDate) }}
            </td>
            <td :data-label="t('fields.finishDate')">
              {{ formatDate(item.finishDate) }}
            </td>
            <td :data-label="t('fields.status')">
              <span
                v-if="['SUCCESS', 'SUPPLEMENT_SUCCESS'].includes(item.status)"
              >
                <span class="success-tag">
                  {{ t('depositStatus.' + item.status) }}
                </span>
              </span>
              <span v-else-if="item.status === 'CLOSED'">
                <span class="danger-tag">
                  {{ t('depositStatus.' + item.status) }}
                </span>
              </span>
              <span v-else-if="item.status === 'PENDING'">
                <span class="warning-tag">
                  {{ t('depositStatus.' + item.status) }}
                </span>
              </span>
              <span v-else>
                <span class="info-tag">-</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="memberDepositInfo.page.records.length === 0">
        <emptyComp />
      </div>
      <el-pagination
        class="pagination"
        @current-change="changeDepositPage"
        layout="total, prev, pager, next"
        :total="memberDepositInfo.page.total"
        :page-size="depositRequest.size"
        :page-count="memberDepositInfo.page.pages"
        :current-page="depositRequest.current"
      />
    </el-form>
  </el-dialog>
  <el-dialog
    :title="t('fields.privilegeRecord')"
    v-model="uiControl.privilegeDialogVisible"
    width="1100px"
    append-to-body
  >
    <el-form label-suffix=" : " style="margin-top: -20px;">
      <div class="info-row-container">
        <el-form-item :label="t('fields.loginName')">
          {{ memberPrivilegeInfo.loginName }}
        </el-form-item>
        <el-form-item :label="t('fields.realName')">
          {{ memberPrivilegeInfo.realName }}
        </el-form-item>
        <el-form-item :label="t('fields.registerTime')">
          {{ memberPrivilegeInfo.regTime }}
        </el-form-item>
      </div>
      <table class="custom-table">
        <thead>
          <tr>
            <th scope="col">{{ t('fields.serialNumber') }}</th>
            <th scope="col">{{ t('fields.privilegeName') }}</th>
            <th scope="col">{{ t('fields.amount') }}</th>
            <th scope="col">{{ t('fields.rollover') }}</th>
            <th scope="col">{{ t('fields.recordTime') }}</th>
          </tr>
        </thead>
        <tbody v-if="memberPrivilegeInfo.page.records.length > 0">
          <tr v-for="item in memberPrivilegeInfo.page.records" :key="item.id">
            <td :data-label="t('fields.serialNumber')">{{ item.serialNumber }}</td>
            <td :data-label="t('fields.privilegeName')">{{ item.privilegeName }}</td>
            <td :data-label="t('fields.amount')">{{ parseInt(store.state.user.siteId) === 10 ? '₩' : '$' }}{{ parseInt(store.state.user.siteId) === 10 ? item.amount.toFixed(0) : item.amount.toFixed(2) }}</td>
            <td :data-label="t('fields.rollover')">{{ item.rollover }}</td>
            <td :data-label="t('fields.recordTime')">
              {{ formatDate(item.recordTime) }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="memberPrivilegeInfo.page.records.length === 0">
        <emptyComp />
      </div>
      <el-pagination
        class="pagination"
        @current-change="changePrivilegePage"
        layout="total, prev, pager, next"
        :total="memberPrivilegeInfo.page.total"
        :page-size="privilegeRequest.size"
        :page-count="memberPrivilegeInfo.page.pages"
        :current-page="privilegeRequest.current"
      />
    </el-form>
  </el-dialog>
  <el-dialog
    :title="t('fields.createMember')"
    v-model="uiControl.createMemberDialogVisible"
    append-to-body
    width="580px"
  >
    <el-form
      ref="createForm"
      class="create-form"
      :model="createMemberForm"
      :rules="createFormRules"
      inline="true"
      size="normal"
      label-width="150px"
    >
      <el-form-item :label="t('fields.loginName')" prop="loginName">
        <el-input
          v-model="createMemberForm.loginName"
          style="width: 350px;"
          maxlength="11"
        />
      </el-form-item>
      <el-form-item :label="t('fields.password')" prop="password">
        <el-input
          v-model="createMemberForm.password"
          type="password"
          style="width: 350px;"
          maxlength="11"
        />
      </el-form-item>
      <el-form-item :label="t('fields.reenterPassword')" prop="reEnterPassword">
        <el-input
          v-model="createMemberForm.reEnterPassword"
          type="password"
          style="width: 350px;"
          maxlength="11"
        />
      </el-form-item>
      <el-form-item :label="t('fields.telephone')" prop="telephone">
        <el-input
          v-model="createMemberForm.telephone"
          style="width: 350px;"
          maxlength="20"
        />
      </el-form-item>
      <el-form-item :label="t('fields.email')" prop="email">
        <el-input v-model="createMemberForm.email" style="width: 350px;" />
      </el-form-item>
      <el-form-item v-if="parseInt(store.state.user.siteId) === 10" :label="t('fields.memberShareRatio')" prop="memberShareRatio">
        <div v-for="item in memberShareRatioList.list" :key="item.code" style="width: 350px; display: flex; margin-bottom:5px;">
          <span>{{ t('affiliateShareRatio.' + item.code) }}</span>
          <el-input
            v-model="item.value"
            style=" width:100px; margin-left: auto;"
          />
          <span style="color:red"> &emsp; (0 - {{ getAffiliateRatio(item.code) }}) </span>
        </div>
      </el-form-item>
      <div class="dialog-footer">
        <el-button @click="uiControl.createMemberDialogVisible = false">
          {{ $t('fields.cancel') }}
        </el-button>
        <el-button type="primary" @click="createMember()">
          {{ $t('fields.confirm') }}
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import { useStore } from '@/store'
import moment from 'moment'
import {
  loadMemberSummary,
  exportMemberSummary,
  loadMemberInfo,
  assignTag,
  assignRemark,
  registerMember,
  editMemberRatio,
  getAffiliateInfo,
  getDownlineAffiliates
} from '../../../api/affiliate'
import { getAffiliateTagList } from '../../../api/affiliate-tag'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { getMemberDepositRecords } from '../../../api/affiliate-deposit-record'
import { getMemberPrivilegeRecords } from '../../../api/affiliate-privilege-record'
import emptyComp from '@/components/empty'
import { required, size } from '../../../utils/validate'
import { getConfigListByGroup } from "../../../api/system-config";
import * as XLSX from 'xlsx'

const store = useStore()
const { t } = useI18n()
const router = useRouter()
const startDate = new Date()
const defaultStartDate = convertDate(
  startDate.setTime(
    moment(startDate)
      .startOf('month')
      .format('x')
  )
)
const defaultEndDate = convertDate(new Date())
const tagList = reactive({
  list: [],
  description: [],
})
let assignTaglist = []
// const table = ref(null)
const selected = reactive({
  tags: [],
})
const memberShareRatioList = reactive({
  list: [],
})
const affiliate = reactive({
  list: []
})
const downlineAffiliate = ref(null);
const showOperation = ref(true);
const filtersExpanded = ref(false)

const uiControl = reactive({
  infoDialogVisible: false,
  tagDialogVisible: false,
  remarkDialogVisible: false,
  depositDialogVisible: false,
  privilegeDialogVisible: false,
  createMemberDialogVisible: false,
  shareRatioDialogVisible: false,
  editBtn: true,
  editType: 'One',
  exporting: false,
  orderBy: [
    // { display: 'totalDeposit', value: 'total_deposit' },
    // { display: 'totalWithdraw', value: 'total_withdraw' },
    // { display: 'lastLoginTime', value: 'last_login_time' },
    // { display: 'registerTime', value: 'reg_time' },
    { display: 'totalDeposit', value: 'totalDeposit' },
    { display: 'totalWithdraw', value: 'totalWithdraw' },
    { display: 'totalBet', value: 'totalBet' },
    { display: 'registerTime', value: 'regTime' },
  ],
  sortType: [
    { display: 'DESC', value: 'DESC' },
    { display: 'ASC', value: 'ASC' },
  ],
})

const memberInfo = reactive({
  loginName: '',
  realName: '',
  status: '',
  totalDeposit: 0,
  totalWithdraw: 0,
  totalBonus: 0,
  totalRebate: 0,
  totalValidBet: 0,
  totalBet: 0,
  totalAdjustment: 0,
  winLoss: 0,
  regTime: '',
  ftdTime: '',
  transferRecord: 0,
  remark: '',
  memberBetRecordSummaryVOList: [],
})

const memberDepositInfo = reactive({
  loginName: '',
  realName: '',
  regTime: '',
  page: {
    pages: 0,
    records: [],
    loading: false,
    total: 0,
    totalDeposit: 0,
  },
})

const memberPrivilegeInfo = reactive({
  loginName: '',
  realName: '',
  regTime: '',
  page: {
    pages: 0,
    records: [],
    loading: false,
    total: 0,
  },
})

const depositRequest = reactive({
  size: 10,
  current: 1,
  loginName: null,
})

const privilegeRequest = reactive({
  size: 10,
  current: 1,
  loginName: null,
  memberId: null,
})

const checkAll = ref(false)
const isIndeterminate = ref(false)
const unAssigned = reactive({
  id: -1,
  description: t('fields.unAssigned'),
})
const dialog = reactive({
  loading: false,
})
const formatMoney = value => {
  if (typeof value !== 'number') {
    return '-'
  }
  // Assuming you want to format to two decimal places
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

const formatDateTime = value => {
  if (!value) {
    return '-'
  }
  const date = new Date(value)
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
}

const formatmTag = tags => {
  if (!Array.isArray(tags) || tags.length === 0) {
    return '-'
  }
  return tags.join(', ')
}

const shortcuts = [
  {
    text: t('fields.today'),
    value: () => {
      const end = new Date()
      const start = new Date()
      return [start, end]
    },
  },
  {
    text: t('fields.yesterday'),
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(
        moment(start)
          .subtract(1, 'days')
          .format('x')
      )
      end.setTime(
        moment(end)
          .subtract(1, 'days')
          .format('x')
      )
      return [start, end]
    },
  },
  {
    text: t('fields.thisWeek'),
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(
        moment(start)
          .startOf('isoWeek')
          .format('x')
      )
      return [start, end]
    },
  },
  {
    text: t('fields.lastWeek'),
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(
        moment(start)
          .subtract(1, 'weeks')
          .startOf('isoWeek')
          .format('x')
      )
      end.setTime(
        moment(end)
          .subtract(1, 'weeks')
          .endOf('isoWeek')
          .format('x')
      )
      return [start, end]
    },
  },
  {
    text: t('fields.thisMonth'),
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(
        moment(start)
          .startOf('month')
          .format('x')
      )
      return [start, end]
    },
  },
  {
    text: t('fields.lastMonth'),
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setTime(
        moment(start)
          .subtract(1, 'months')
          .startOf('month')
          .format('x')
      )
      end.setTime(
        moment(end)
          .subtract(1, 'months')
          .endOf('month')
          .format('x')
      )
      return [start, end]
    },
  },
]

const request = reactive({
  regTime: null,
  recordTime: [defaultStartDate, defaultEndDate],
  loginName: null,
  realName: null,
  telephone: null,
  email: null,
  isBet: '-1',
  depositMinAmount: null,
  depositMaxAmount: null,
  size: 20,
  current: 1,
  memberTags: [],
  orderBy: uiControl.orderBy[0].value,
  sortType: uiControl.sortType[0].value,
  downlineAffiliate: null,
  depositedButRecentNoDeposit: false,
  thisMonthRegisterAndNoDeposit: false
})

const sortableColumns = [
  { label: 'totalDeposit', orderBy: 'totalDeposit' },
  { label: 'totalWithdraw', orderBy: 'totalWithdraw' },
  { label: 'totalBet', orderBy: 'totalBet' },
  // net profit is not sortable
  { label: 'netProfit', orderBy: null },
  { label: 'registerTime', orderBy: 'regTime' },
]

function sortBy(orderBy) {
  if (request.orderBy === orderBy) {
    request.sortType = request.sortType === 'DESC' ? 'ASC' : 'DESC'
  } else {
    request.orderBy = orderBy
    request.sortType = 'DESC'
  }
  request.current = 1
  loadAffiliateMembers()
}

const memberRequest = reactive({
  memberId: null,
  recordTime: [defaultStartDate, defaultEndDate],
})

const tagRequest = reactive({
  tags: [],
})

const selectedMember = reactive({
  id: null,
  loginName: null,
  remark: null,
  shareRatio: null,
})

const selectedMemberList = reactive({
  id: [],
  loginName: [],
})

const page = reactive({
  pages: 0,
  records: [],
  loading: false,
})

const createForm = ref(null)
const createMemberForm = reactive({
  id: null,
  loginName: null,
  password: null,
  reEnterPassword: null,
  telephone: null,
  email: null,
  siteId: null,
  memberShareRatio: null,
})

const affInfo = reactive({
  affiliateCode: null,
  affiliateLevel: null,
  downlineAffiliate: 0,
  downlineMember: 0,
  commission: 0,
  revenueShare: 0,
  shareRatio: [],
})

const validatePassword = (rule, value, callback) => {
  if (value !== '' && createMemberForm.reEnterPassword !== '') {
    createForm.value.validateField('reEnterPassword')
  }
  callback()
}

const validateReEnterPassword = (rule, value, callback) => {
  if (value !== createMemberForm.password) {
    callback(new Error(t('message.twoPasswordNotMatch')))
  }
  callback()
}

const validateMemberShareRatio = (rule, value, callback) => {
  memberShareRatioList.list.forEach((item) => {
    if (item.value === '' || item.value < 0 || item.value > 1) {
      callback(new Error(t('message.validateShareRatioFormat')))
    }
  })
  callback()
}

const createFormRules = reactive({
  loginName: [
    required(t('message.requiredLoginName')),
    size(6, 12, t('message.length6To12')),
  ],
  password: [
    required(t('message.requiredPassword')),
    size(6, 12, t('message.length6To12')),
    { validator: validatePassword, trigger: 'blur' },
  ],
  reEnterPassword: [
    required(t('message.reenterPassword')),
    { validator: validateReEnterPassword, trigger: 'blur' },
  ],
  telephone: [required(t('message.requiredTelephone'))],
  memberShareRatio: [{ validator: validateMemberShareRatio, trigger: 'blur' }],
})

function convertDate(date) {
  return moment(date).format('YYYY-MM-DD')
}

function disabledDate(time) {
  return time.getTime() > new Date().getTime()
}

function resetQuery() {
  request.regTime = null
  request.recordTime = [defaultStartDate, defaultEndDate]
  request.loginName = null
  request.realName = null
  request.telephone = null
  request.email = null
  request.isBet = '-1'
  request.depositMinAmount = null
  request.depositMaxAmount = null
  request.downlineAffiliate = null
  selected.tags = []
  checkAll.value = false
  request.validBetMaxAmount = null
  request.validBetMinAmount = null
  request.depositedButRecentNoDeposit = false
  request.thisMonthRegisterAndNoDeposit = false
}

async function loadAffiliateMembers() {
  selectedMemberList.id.length = 0
  selectedMemberList.loginName.length = 0
  downlineAffiliate.value = null
  showOperation.value = true
  // table.value.clearSelection()
  uiControl.editBtn = true
  page.loading = true
  const { userId, query } = buildMemberQuery()
  if (request.downlineAffiliate !== null && request.downlineAffiliate.trim() !== '') {
    downlineAffiliate.value = request.downlineAffiliate
    showOperation.value = false
  }
  const { data: ret } = await loadMemberSummary(userId, query)

  page.pages = ret.pages
  page.records = ret.records
  page.loading = false
}

function buildMemberQuery() {
  const requestCopy = { ...request }
  const query = {}
  Object.entries(requestCopy).forEach(([key, value]) => {
    if (value) {
      query[key] = value
    }
  })
  if (request.regTime !== null) {
    if (request.regTime.length === 2) {
      query.regTime = request.regTime.join(',')
    }
  } else {
    query.regTime = null
  }
  if (request.recordTime !== null) {
    if (request.recordTime.length === 2) {
      query.recordTime = request.recordTime.join(',')
    }
  }
  query.siteId = store.state.user.siteId
  query.memberTypes = 'NORMAL,TEST'
  switch (query.isBet) {
    case '-1':
      query.isBet = null
      break
    case '1':
      query.isBet = true
      break
    case '0':
      query.isBet = false
      break
  }
  query.memberTags = tagList.list.filter(function(obj) {
    return selected.tags.includes(obj.description)
  })
  query.memberTags = query.memberTags
    .map(function(obj) {
      return obj.id
    })
    .join(',')

  let userId = store.state.user.id;
  if (request.downlineAffiliate !== null && request.downlineAffiliate.trim() !== '') {
    userId = request.downlineAffiliate
  }
  return { userId, query }
}

async function exportMembers() {
  uiControl.exporting = true
  try {
    const { userId, query } = buildMemberQuery()
    delete query.size
    delete query.current
    const { data } = await exportMemberSummary(userId, query)
    const records = Array.isArray(data) ? data : (data?.records || [])
    const rows = records.map(item => ({
      [t('fields.loginName')]: item.loginName,
      [t('fields.totalDeposit')]: item.totalDeposit,
      [t('fields.totalWithdraw')]: item.totalWithdraw,
      [t('fields.totalBet')]: item.totalBet,
      [t('fields.netProfit')]: item.revenueShare,
      [t('fields.registerTime')]: formatDateTime(item.regTime),
      [t('fields.lastLoginTime')]: formatDateTime(item.lastLoginTime),
      [t('fields.memberTag')]: formatmTag(item.tagDesc),
    }))
    const worksheet = XLSX.utils.json_to_sheet(rows)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Members')
    XLSX.writeFile(workbook, `members_${moment().format('YYYYMMDDHHmmss')}.xlsx`)
  } finally {
    uiControl.exporting = false
  }
}

function changePage(page) {
  if (request.current >= 1) {
    request.current = page
    loadAffiliateMembers()
  }
}

function changeDepositPage(page) {
  if (depositRequest.current >= 1) {
    depositRequest.current = page
    loadDepositRecords()
  }
}

function changePrivilegePage(page) {
  if (privilegeRequest.current >= 1) {
    privilegeRequest.current = page
    loadPrivilegeRecords()
  }
}

function formatTag(tags) {
  if (tags.length > 0) {
    tags = tagList.list.filter(function(obj) {
      return tags.includes(obj.id)
    })
    tags = tags
      .map(function(obj) {
        return obj.description
      })
      .join(',')
    return tags
  }
  return '-'
}

async function loadAllTags() {
  let userId = store.state.user.id
  if (downlineAffiliate.value) {
    userId = downlineAffiliate.value
  }
  const { data: ret } = await getAffiliateTagList(userId)
  tagList.list = ret
  assignTaglist = JSON.parse(JSON.stringify(ret))
  tagList.list.push(unAssigned)
  tagList.description = tagList.list.map(function(obj) {
    return obj.description
  })
}

function goToTagSetting() {
  router.push('/downline/tag-setting')
}

function transferRedirect(name) {
  router.push(`/affiliate/transfer?user=${name}`)
}

function showGameRecord(name, affiliate) {
  if (affiliate) {
    router.push(`/downline/game-record?user=${name}&affiliate=${affiliate}`)
  } else {
    router.push(`/downline/game-record?user=${name}`)
  }
}

function showDepositRecord(member) {
  memberDepositInfo.loginName = member.loginName
  memberDepositInfo.realName = member.realName
  memberDepositInfo.regTime = member.regTime
  uiControl.depositDialogVisible = true
  depositRequest.current = 1
  depositRequest.loginName = member.loginName
  depositRequest.siteId = store.state.user.siteId
  loadDepositRecords()
}

async function loadDepositRecords() {
  memberDepositInfo.page.loading = true
  let userId = store.state.user.id
  if (downlineAffiliate.value) {
    userId = downlineAffiliate.value
  }
  const { data: ret } = await getMemberDepositRecords(
    userId,
    depositRequest
  )
  memberDepositInfo.page = ret
  memberDepositInfo.page.loading = false
}

function showPrivilegeRecord(member) {
  memberPrivilegeInfo.loginName = member.loginName
  memberPrivilegeInfo.realName = member.realName
  memberPrivilegeInfo.regTime = member.regTime
  uiControl.privilegeDialogVisible = true
  privilegeRequest.current = 1
  privilegeRequest.memberId = member.id
  privilegeRequest.loginName = member.loginName
  privilegeRequest.siteId = store.state.user.siteId
  loadPrivilegeRecords()
}

async function loadPrivilegeRecords() {
  memberPrivilegeInfo.page.loading = true
  let userId = store.state.user.id
  if (downlineAffiliate.value) {
    userId = downlineAffiliate.value
  }
  const { data: ret } = await getMemberPrivilegeRecords(
    userId,
    privilegeRequest
  )
  memberPrivilegeInfo.page = ret
  memberPrivilegeInfo.page.loading = false
}

function handleCheckAll(val) {
  selected.tags = val ? tagList.description : []
  isIndeterminate.value = false
}

function handleCheckedTags(value) {
  const checkedCount = value.length
  checkAll.value = checkedCount === tagList.description.length
  isIndeterminate.value =
    checkedCount > 0 && checkedCount < tagList.description.length
}

async function showMemberInfo(row) {
  if (row) {
    uiControl.infoDialogVisible = true
    memberRequest.recordTime = [defaultStartDate, defaultEndDate]
    memberRequest.memberId = row.id
    memberInfo.tags = formatTag(row.tags)
    memberInfo.remark = row.remark
  }
  dialog.loading = true
  let userId = store.state.user.id
  if (downlineAffiliate.value) {
    userId = downlineAffiliate.value
  }
  const { data: ret } = await loadMemberInfo(
    userId,
    memberRequest.memberId,
    memberRequest.recordTime.join(','),
    memberRequest.gameType
  )
  Object.entries(ret).forEach(([key, value]) => {
    if (value) {
      memberInfo[key] = value
    } else {
      memberInfo[key] = 0
    }
  })
  dialog.loading = false
}

function showEditTag(member) {
  selectedMember.id = member.id
  selectedMember.loginName = member.loginName
  tagRequest.tags = assignTaglist.filter(function(obj) {
    return member.tags.includes(obj.id)
  })
  tagRequest.tags = tagRequest.tags.map(function(obj) {
    return obj.description
  })
  uiControl.editType = 'One'
  uiControl.tagDialogVisible = true
}

function showBatchEditTag() {
  tagRequest.tags = []
  uiControl.editType = 'Many'
  uiControl.tagDialogVisible = true
}

async function submitTag() {
  let userId = store.state.user.id
  if (downlineAffiliate.value) {
    userId = downlineAffiliate.value
  }
  tagRequest.tags = assignTaglist.filter(function(obj) {
    return tagRequest.tags.includes(obj.description)
  })
  tagRequest.tags = tagRequest.tags.map(function(obj) {
    return obj.id
  })
  if (uiControl.editType === 'One') {
    await assignTag(userId, selectedMember.id, tagRequest.tags)
    selectedMember.id = null
    selectedMember.loginName = null
  } else {
    await assignTag(
      userId,
      selectedMemberList.id.join(','),
      tagRequest.tags
    )
  }
  ElMessage({ message: t('message.editSuccess'), type: 'success' })
  await loadAffiliateMembers()
  uiControl.tagDialogVisible = false
}

function handleSelectionChange(val) {
  selectedMemberList.loginName = val.map(function(item) {
    return item.loginName
  })
  selectedMemberList.id = val.map(function(item) {
    return item.id
  })
  if (selectedMemberList.id.length === 0) {
    uiControl.editBtn = true
  } else {
    uiControl.editBtn = false
  }
}

function showEditRemark(member) {
  selectedMember.id = member.id
  selectedMember.loginName = member.loginName
  uiControl.remarkDialogVisible = true
  selectedMember.remark = member.remark
}

function showEditShareRatio(member) {
  selectedMember.id = member.id
  selectedMember.shareRatio = member.shareRatio
  if (selectedMember.shareRatio === null || selectedMember.shareRatio === undefined) {
    selectedMember.shareRatio = []
  }
  for (let item = 0; item < memberShareRatioList.list.length; item++) {
    if (!selectedMember.shareRatio.some(child => child.code === memberShareRatioList.list[item].code)) {
      selectedMember.shareRatio.push({ code: memberShareRatioList.list[item].code, value: 0 })
    }
  }
  uiControl.shareRatioDialogVisible = true
}

async function submitRemark() {
  let userId = store.state.user.id
  if (downlineAffiliate.value) {
    userId = downlineAffiliate.value
  }
  await assignRemark(
    userId,
    selectedMember.id,
    selectedMember.remark
  )
  ElMessage({ message: t('message.editSuccess'), type: 'success' })
  await loadAffiliateMembers()
  uiControl.remarkDialogVisible = false
}

async function submitShareRatio() {
  const editedRatio = selectedMember.shareRatio.map(item => item.code + ":" + item.value).join(',');
  await editMemberRatio(
    selectedMember.id,
    editedRatio
  )
  ElMessage({ message: t('message.editSuccess'), type: 'success' })
  await loadAffiliateMembers()
  uiControl.shareRatioDialogVisible = false
}

function formatDate(date) {
  return date ? moment(date).format('YYYY/MM/DD HH:mm:ss') : '-'
}

function showCreateMember() {
  if (createForm.value) {
    createForm.value.resetFields()
  }
  createMemberForm.siteId = store.state.user.siteId
  uiControl.createMemberDialogVisible = true
}

async function createMember() {
  createForm.value.validate(async valid => {
    if (valid) {
      if (parseInt(createMemberForm.siteId) === 10) {
        createMemberForm.memberShareRatio = memberShareRatioList.list.map(item => item.code + ":" + item.value).join(',');
      }
      await registerMember(createMemberForm)
      uiControl.createMemberDialogVisible = false
      ElMessage({ message: t('message.addSuccess'), type: 'success' })
      await loadAffiliateMembers()
    }
  })
}

function getAffiliateRatio(code) {
  const shareRatio = affInfo.shareRatio.filter(item => item.code === code);
  return shareRatio === null || shareRatio === undefined || shareRatio.length === 0 ? 0 : shareRatio[0].value;
}

async function getAllAffiliateDownlines() {
  const { data: downlines } = await getDownlineAffiliates();
  affiliate.list = downlines;
}

onMounted(async () => {
  await loadAllTags()
  await loadAffiliateMembers()
  await getAllAffiliateDownlines()
  const { data: aff } = await getAffiliateInfo(store.state.user.id)
  Object.keys({ ...aff }).forEach(field => {
    affInfo[field] = aff[field]
  })
  getConfigListByGroup('AGENT_SHARE_RATIO', store.state.user.siteId).then(res => {
    res.data.forEach(ratio => {
      memberShareRatioList.list.push({
        code: ratio.code,
        value: 0
      })
    })
  });
})
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.header-container {
  margin: 40px 0 20px;
  display: flex;
}

.sortable-th {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.sort-caret {
  display: inline-flex;
  flex-direction: column;
  vertical-align: middle;
  margin-left: 4px;
  font-size: 8px;
  line-height: 9px;
  color: #c0c4cc;

  .active {
    color: #3f8cff;
  }
}

.box-card {
  ::v-deep(.el-card__body) {
    padding: 0;
  }
}

.mobile-filter-toggle {
  display: none;
}

.mobile-batch-edit {
  display: none;
}

.member-tag-filter {
  margin: 20px;
}

.inputs-wrap {
  margin: 0px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  .input-small {
    width: 100%;
    max-width: 200px;
    &.el-range-editor--small.el-input__inner {
      height: 40px;
      max-width: 300px;
    }
  }
  .btn-grp {
    display: flex;
  }
  .el-row .el-col {
    display: flex;
    margin-bottom: 10px;
  }
}

.number-division {
  display: inline-flex;
  align-items: center;
}

.amount-input input {
  border: 5px solid red;
}

.input-min {
  width: 55%;

  :deep(.el-input-group__append) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.el-input-group {
  vertical-align: unset;
}
.input-max {
  width: 40%;

  :deep(.el-input__inner) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

:deep(.el-date-editor.el-input__inner) {
  width: 100%;
}

.scrollable-container {
  max-height: 600px;
  overflow-y: auto;
}

.info-container {
  border-radius: 5px;
  border: 1px solid #f2f2f6;
  padding: 0 20px;
  margin: 24px 0;
}

.info-row-container {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-form-item {
    flex: 1;
    margin-bottom: 0;
  }
}

.el-form-item {
  flex: 1;
  margin-bottom: 0;
}

.create-form > * {
  margin-bottom: 22px;
}

.info-row-container:not(:first-child) {
  border-top: 1px solid #f2f2f6;
}

.dialog-footer {
  display: flex;
  justify-content: center;
}
.relativerow {
  position: relative;
}
.absbuttons {
  position: absolute;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--el-border-color-light);
  box-shadow: var(--el-dropdown-menu-box-shadow);
  right: 0px;
  bottom: 0px;
  button {
    font-size: 12px;
    cursor: pointer;
    border: 0;
    padding: 10px;
    background: #ffffff;
    &:hover {
      background: #ecf5ff;
      color: #66b1ff;
    }
  }
}

@media (max-width: 768px) {
  .ph2-member-page .mobile-filter-toggle {
    width: calc(100% - 32px);
    min-height: 44px;
    margin: 12px 16px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--el-color-primary);
    font: inherit;
    font-weight: 600;
    background: var(--el-color-primary-light-9);
    border: 1px solid var(--el-color-primary-light-5);
    border-radius: 8px;
    cursor: pointer;

    &.is-expanded {
      margin-bottom: 0;
      background: var(--el-color-primary-light-8);
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  .ph2-member-page .filter-toggle-icon {
    width: 9px;
    height: 9px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: rotate(45deg);
    transition: transform 0.2s ease;

    &.is-expanded {
      transform: rotate(225deg);
    }
  }

  .ph2-member-page .member-filters.is-collapsed {
    display: none;
  }

  .ph2-member-page .member-filters {
    margin: 0 16px 12px;
    padding: 12px;
    background: #f7faff;
    border: 1px solid var(--el-color-primary-light-5);
    border-top: 0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .ph2-member-page .member-tag-filter {
    padding-bottom: 10px;
    margin: 0 0 10px;
    border-bottom: 1px solid var(--el-border-color-lighter);

    :deep(.el-row) {
      margin-right: 0 !important;
      margin-left: 0 !important;
    }

    :deep(.el-col) {
      padding-right: 0 !important;
      padding-left: 0 !important;
    }

    :deep(.el-col:first-child .el-form-item__content) {
      display: none;
      min-height: 0;
    }

    :deep(.el-col:first-child .el-form-item__label) {
      padding-bottom: 0;
    }

  }

  .ph2-member-page .inputs-wrap {
    margin: 0;

    .el-row {
      width: 100%;
      gap: 0 !important;
      margin-right: 0 !important;
      margin-left: 0 !important;
    }

    .el-row .el-col {
      width: 100%;
      max-width: 100%;
      flex: 0 0 100%;
      padding-right: 0 !important;
      padding-left: 0 !important;
      margin-bottom: 10px;
    }

    .input-small {
      max-width: none;
    }

    .input-min {
      width: 55%;
    }

    .input-max {
      width: 45%;
    }
  }

  .ph2-member-page {
    :deep(.el-card__header) {
      padding: 14px 16px;
    }

    :deep(.el-form-item) {
      display: block;
      margin-bottom: 0;
    }

    :deep(.el-form-item__label) {
      height: auto;
      min-height: 20px;
      padding: 0 0 4px;
      color: var(--el-text-color-regular);
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
    }

    :deep(.el-form-item__content) {
      width: 100%;
      min-height: 36px;
      line-height: 36px;
    }

    :deep(.el-input__inner),
    :deep(.el-range-editor.el-input__inner),
    :deep(.el-button) {
      min-height: 36px;
    }

    :deep(.el-input__inner),
    :deep(.el-range-editor.el-input__inner) {
      background: #fff;
    }

    :deep(.el-checkbox) {
      height: 28px;
      margin-right: 14px;
    }

    .memberTag {
      top: -2px;

      :deep(.el-button) {
        padding: 8px 10px;
      }
    }

    .member-filters > .inputs-wrap:nth-last-child(1) {
      .el-row {
        gap: 10px !important;
      }

      .el-row .el-col {
        width: calc(50% - 5px);
        flex: 0 0 calc(50% - 5px);
      }

      .el-row .el-col:last-child {
        width: 100%;
        flex: 0 0 100%;
        margin-top: 0;
      }
    }

    .member-search-actions {
      display: grid !important;
      grid-template-columns: auto auto;
      gap: 6px;
      width: 100%;
      justify-content: center;
      padding-top: 12px;
      margin-top: 2px !important;
      border-top: 1px solid var(--el-border-color-lighter);

      :deep(.el-button) {
        width: auto;
        min-width: 0;
        min-height: 36px;
        height: 36px;
        padding: 8px 10px;
        margin-left: 0;
        display: inline-flex;
        gap: 4px;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        line-height: 1.2;
        white-space: normal;
      }

      :deep(.el-button span) {
        line-height: 1.2;
        text-align: center;
        white-space: normal;
      }

      :deep(.el-button:nth-child(1) span),
      :deep(.el-button:nth-child(2) span) {
        white-space: nowrap;
      }

      :deep(.el-button:nth-child(3) span) {
        max-width: 100%;
        white-space: nowrap;
      }

      .mobile-batch-edit {
        width: auto;
        display: inline-flex;
        grid-column: 1 / -1;
        justify-self: center;
      }
    }

    .member-batch-actions {
      flex-wrap: wrap;

      :deep(.el-button) {
        display: none;
      }
    }
  }

  .memberTag {
    position: absolute;
    top: -20px;
    right: 0;
  }
  .info-row-container {
    flex-direction: column;
  }
  // .inputs-wrap {
  //   flex-direction: column;
  //   gap: 10px;
  //   .el-input--small {
  //     width: 100% !important;
  //     max-width: unset !important;
  //     margin: 0 !important;
  //     .el-button {
  //       margin: 0 !important;
  //     }
  //   }
  //   .input-small {
  //     max-width: unset;
  //     width: 100%;
  //     &.el-range-editor--small.el-input__inner {
  //       max-width: unset;
  //     }
  //   }
  // }
}
</style>
<style>
.dialog900 .el-dialog {
  max-width: 900px;
}
.dialog400 .el-dialog {
  max-width: 400px;
}
</style>
